import {
  ContentBlocksModuleLayout,
  ModuleContentBlocksContent,
  ModuleType,
} from "entities/modules/types";
import { THREE_CARD_BLOCK_KEY } from "entities/modules/utils";
import { ref, uploadBytes } from "firebase/storage";
import { store } from "shared/api/firebase";
import { getImageFile } from "shared/api/firebase/getImageFile";
import { PageModuleDataToInsert } from "../types";

export const copyContentBlockImages = async (
  module: PageModuleDataToInsert,
  copyPath: string,
  key: string,
): Promise<ModuleContentBlocksContent[] | null> => {
  if (
    module.type !== ModuleType.ContentBlocks ||
    !module.contentBlocks ||
    !module.contentBlocks?.length
  ) {
    return null;
  }

  try {
    if (
      module.layout === ContentBlocksModuleLayout.ThreeCardBlock &&
      module.contentBlocks?.some(
        (block: ModuleContentBlocksContent) => block.backgroundImage !== null,
      )
    ) {
      return await Promise.all(
        module.contentBlocks.map(
          async (item, index): Promise<ModuleContentBlocksContent> => {
            if (!item.backgroundImage) {
              return item;
            }
            const path = `${key}/${THREE_CARD_BLOCK_KEY}-${index}`;
            const imgStorageRef = ref(store, path);
            const file = await getImageFile(
              `${copyPath}/${THREE_CARD_BLOCK_KEY}-${index}`,
            );

            if (!file) {
              return item;
            }

            await uploadBytes(imgStorageRef, file);
            return { ...item, backgroundImage: path };
          },
        ),
      );
    }

    return module.contentBlocks;
  } catch (err) {
    console.error("Failed to copy content blocks images", err);
    throw err;
  }
};
